import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row, Modal } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

// img
import v1 from "../../../../Assets/images/v1.png";

// css
import styles from "./serviceDetail.module.scss";
import Slider from "react-slick";
import { APPROVING_DRIVER, GET_VENDOR_BY_ID } from "../../../../services/ApiCalls";
import config from "../../../../config";

const VendorDetail = () => {
  const [vendorDatas, setVendorDatas] = useState({});
  const { id } = useParams();
  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const navigate = useNavigate();
  const [widgetCode, setWidgetCode] = useState(null);
  const [widgetCopied, setWidgetCopied] = useState(false);

  const handleImageClick = (image) => {
    setSelectedImage(image);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedImage(null);
  };
  const getService = async (id) => {
    try {
      const vendorRes = await GET_VENDOR_BY_ID(id);
      console.log(vendorRes, "vendordata");
      if (vendorRes.status === 200) {
        const data = vendorRes?.data;
        setVendorDatas(data);
        handleCopyVendorWidget(data)

      } else {
        toast.error(vendorRes?.data?.message);
      }
    } catch (error) {
      toast.error("something went wrong");
    }
  };

  useEffect(() => {
    getService(id);
  }, [id]);

  const approveVendorHandler = async (item, status) => {
    try {
      const res = await APPROVING_DRIVER({ providerId: id, status });
      console.log(res, "itemchk");

      if (res.data.status === "success") {
        toast.success(res.data.message);
        navigate("/vendors");
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      toast.error("something went wrong");
    }
  };

  const handleCopyVendorWidget = (item) => {
    let widgetHtml = `<iframe src="${config.baseURL}/widget/get-it-by-delivit/${item?._id}?price={productPrice}&return_url={callbackUrl}" style="border:none;height:45px"></iframe>`


    setWidgetCode(widgetHtml);
  }

  const handleCopyWidget = () => {
    navigator.clipboard.writeText(widgetCode)
      .then(() => {
        toast.success('Widget copied to clipboard!');
      })
      .catch(err => {
        toast.error('Failed to copy text:', err);
      });
    setWidgetCopied(true)
  }
  console.log("vendorDatas.status", vendorDatas.status)
  return (
    <>
      <section
        className={`${styles.ServiceDetail} VendorDetail py-3 position-relative`}
      >
        <Container>
          <Row>
            {/* <h5 className="d-flex justify-content-end">Approve</h5> */}
            <Col lg="12" className="d-flex justify-content-end">
              <div className="ActnBtn gap-10 d-flex align-items-center ">
                {/* {item.status == "created" ? (
                      <>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="33"
                          height="33"
                          viewBox="0 0 33 33"
                          fill="none"
                        >
                          <circle cx="16.5" cy="16.5" r="16.5" fill="#D9D9D9" />
                          <path
                            d="M11.1376 21.8675C10.8434 21.8846 10.554 21.7868 10.3306 21.5947C9.88985 21.1514 9.88985 20.4354 10.3306 19.992L19.9807 10.3419C20.4391 9.91295 21.1583 9.93679 21.5872 10.3952C21.9751 10.8097 21.9977 11.4468 21.6402 11.8877L11.9332 21.5947C11.7126 21.784 11.4279 21.8816 11.1376 21.8675Z"
                            fill="white"
                          />
                          <path
                            d="M20.7766 21.8675C20.4784 21.8662 20.1926 21.7479 19.9809 21.5379L10.3308 11.8877C9.92247 11.4109 9.97798 10.6934 10.4548 10.285C10.8803 9.92061 11.5079 9.92061 11.9334 10.285L21.6404 19.9352C22.0987 20.3642 22.1224 21.0835 21.6933 21.5418C21.6763 21.56 21.6586 21.5777 21.6404 21.5947C21.4027 21.8014 21.0899 21.9002 20.7766 21.8675Z"
                            fill="white"
                          />
                        </svg>
                      </>
                    ) : (
                      <>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="33"
                          height="33"
                          viewBox="0 0 33 33"
                          fill="none"
                        >
                          <circle cx="16.5" cy="16.5" r="16.5" fill="#C11111" />
                          <path
                            d="M11.1376 21.8675C10.8434 21.8846 10.554 21.7868 10.3306 21.5947C9.88985 21.1514 9.88985 20.4354 10.3306 19.992L19.9807 10.3419C20.4391 9.91295 21.1583 9.93679 21.5872 10.3952C21.9751 10.8097 21.9977 11.4468 21.6402 11.8877L11.9332 21.5947C11.7126 21.784 11.4279 21.8816 11.1376 21.8675Z"
                            fill="white"
                          />
                          <path
                            d="M20.7766 21.8675C20.4784 21.8662 20.1926 21.7479 19.9809 21.5379L10.3308 11.8877C9.92247 11.4109 9.97798 10.6934 10.4548 10.285C10.8803 9.92061 11.5079 9.92061 11.9334 10.285L21.6404 19.9352C22.0987 20.3642 22.1224 21.0835 21.6933 21.5418C21.6763 21.56 21.6586 21.5777 21.6404 21.5947C21.4027 21.8014 21.0899 21.9002 20.7766 21.8675Z"
                            fill="white"
                          />
                        </svg>
                      </>
                    )} */}
                {["approved", "active"].includes(vendorDatas.status) ? (
                  <>
                    <h5 className="fw-sbold themeBlue">Reject</h5>

                    <svg
                      onClick={(item) => approveVendorHandler(item, "rejected")}
                      xmlns="http://www.w3.org/2000/svg"
                      width="33"
                      height="33"
                      viewBox="0 0 33 33"
                      fill="none"
                    >
                      <circle cx="16.5" cy="16.5" r="16.5" fill="#C11111" />
                      <path
                        d="M11.1376 21.8675C10.8434 21.8846 10.554 21.7868 10.3306 21.5947C9.88985 21.1514 9.88985 20.4354 10.3306 19.992L19.9807 10.3419C20.4391 9.91295 21.1583 9.93679 21.5872 10.3952C21.9751 10.8097 21.9977 11.4468 21.6402 11.8877L11.9332 21.5947C11.7126 21.784 11.4279 21.8816 11.1376 21.8675Z"
                        fill="white"
                      />
                      <path
                        d="M20.7766 21.8675C20.4784 21.8662 20.1926 21.7479 19.9809 21.5379L10.3308 11.8877C9.92247 11.4109 9.97798 10.6934 10.4548 10.285C10.8803 9.92061 11.5079 9.92061 11.9334 10.285L21.6404 19.9352C22.0987 20.3642 22.1224 21.0835 21.6933 21.5418C21.6763 21.56 21.6586 21.5777 21.6404 21.5947C21.4027 21.8014 21.0899 21.9002 20.7766 21.8675Z"
                        fill="white"
                      />
                    </svg>
                  </>
                ) : (
                  <>
                    <h5 className="fw-sbold themeBlue">Approve</h5>

                    <svg
                      onClick={(item) => approveVendorHandler(item, "approved")}
                      xmlns="http://www.w3.org/2000/svg"
                      width="33"
                      height="33"
                      viewBox="0 0 33 33"
                      fill="none"
                    >
                      <circle cx="16.5" cy="16.5" r="16.5" fill="#D9D9D9" />
                      <path
                        d="M24.4699 11.2886C23.7596 10.5783 22.6097 10.5783 21.8994 11.2886L13.2104 19.9776L10.1019 16.8691C9.39159 16.1588 8.23821 16.1588 7.53142 16.8691C6.82462 17.5794 6.8211 18.7328 7.53142 19.4396L11.9269 23.8351C12.6372 24.5454 13.7871 24.5454 14.4974 23.8351L24.4699 13.8591C25.1767 13.1488 25.1767 11.9989 24.4699 11.2886Z"
                        fill="white"
                      />
                    </svg>
                  </>
                )}
              </div>
            </Col>
          </Row>
          <Row className="justify-content-between">


            {/* Modal for Image Preview */}
            <Modal show={showModal} onHide={handleClose} centered>
              <Modal.Header closeButton>
                {/* <Modal.Title>Image Preview</Modal.Title> */}
              </Modal.Header>
              <Modal.Body className="text-center">
                {selectedImage && (
                  <img
                    src={selectedImage}
                    alt="Document Preview"
                    className="img-fluid"
                    style={{ maxHeight: "500px" }}
                  />
                )}
              </Modal.Body>
            </Modal>
            <Col lg="6" className="my-2">
              <h5 className="m-0 pb-2 fw-sbold themeBlue mt-4">
                Vendor Details:
              </h5>
              <div className="box cardCstm p-3 px-lg-4 position-relative">
                <Form>
                  <Row className="justify-content-center">
                    {vendorDatas?.profileImage &&
                      <Col lg="12" className="my-2">
                        <div className={`${styles.featuredImage} featuredImage`}>
                          <Slider {...settings}>
                            <img
                              src={vendorDatas?.profileImage}
                              alt=""
                              height={150}
                              width={150}
                              // className={`img-fluid w-100 object-fit-contain`}
                              // className="img-fluid"
                              // style={{ maxHeight: "150", width: "150px" }}
                              className=" object-fit-contain"
                              onClick={() =>
                                handleImageClick(vendorDatas?.profileImage)
                              }
                            />
                          </Slider>
                        </div>
                      </Col>
                    }
                    <Col lg="12" className="my-2">
                      <ul className="list-unstyled ps-0 mb-0 noLastBorder">
                        <li className="py-2 d-flex align-items-start justify-content-between gap-10">
                          <label
                            htmlFor=""
                            className={`${styles.formLabel} fw-sbold mb-0 form-label themeClr w-50`}
                          >
                            Business Name
                          </label>
                          <p className=" m-0 fw-sbold w-75">
                            {vendorDatas?.name}
                          </p>
                        </li>
                        <li className="py-2 d-flex align-items-start justify-content-between gap-10">
                          <label
                            htmlFor=""
                            className={`${styles.formLabel} fw-sbold mb-0 form-label themeClr w-50`}
                          >
                            Business Email
                          </label>
                          <p className=" m-0 fw-sbold w-75">
                            {vendorDatas?.email}
                          </p>
                        </li>
                        <li className="py-2 d-flex align-items-start justify-content-between gap-10">
                          <label
                            htmlFor=""
                            className={`${styles.formLabel} fw-sbold mb-0 form-label themeClr w-50`}
                          >
                            Mobile Number
                          </label>
                          <p className=" m-0 fw-sbold w-75">
                            {vendorDatas?.mobileNumber}
                          </p>
                        </li>


                      </ul>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Col>
            <Col lg="6" className="my-2">
              <h5 className="m-0 pb-2 fw-sbold themeBlue mt-4">
                Address Details:
              </h5>
              <div className="box cardCstm p-3 px-lg-4 position-relative">
                <ul>

                  <li className="py-2 d-flex align-items-start justify-content-between gap-10">
                    <label
                      htmlFor=""
                      className={`${styles.formLabel} fw-sbold mb-0 form-label themeClr w-50`}
                    >
                      Store Location
                    </label>
                    <p className=" m-0 fw-sbold w-75">
                      {vendorDatas?.address}
                    </p>
                  </li>
                  <li className="py-2 d-flex align-items-start justify-content-between gap-10">
                    <label
                      htmlFor=""
                      className={`${styles.formLabel} fw-sbold mb-0 form-label themeClr w-50`}
                    >
                      City
                    </label>
                    <p className=" m-0 fw-sbold w-75">
                      {vendorDatas?.city}
                    </p>
                  </li>
                  <li className="py-2 d-flex align-items-start justify-content-between gap-10">
                    <label
                      htmlFor=""
                      className={`${styles.formLabel} fw-sbold mb-0 form-label themeClr w-50`}
                    >
                      State / Province
                    </label>
                    <p className=" m-0 fw-sbold w-75">
                      {vendorDatas?.state}
                    </p>
                  </li>
                  <li className="py-2 d-flex align-items-start justify-content-between gap-10">
                    <label
                      htmlFor=""
                      className={`${styles.formLabel} fw-sbold mb-0 form-label themeClr w-50`}
                    >
                      Postal / ZIP Code
                    </label>
                    <p className=" m-0 fw-sbold w-75">
                      {vendorDatas?.pincode}
                    </p>
                  </li>
                  <li className="py-2 d-flex align-items-start justify-content-between gap-10">
                    <label
                      htmlFor=""
                      className={`${styles.formLabel} fw-sbold mb-0 form-label themeClr w-50`}
                    >
                      Country
                    </label>
                    <p className=" m-0 fw-sbold w-75">
                      {vendorDatas?.country}
                    </p>
                  </li>
                </ul>
              </div>
            </Col>

            <Col lg="6" className="my-2">
              <h5 className="m-0 pb-2 fw-sbold themeBlue mt-4">
                Bank Account Details:
              </h5>
              <div className="box cardCstm p-3 px-lg-4 position-relative">
                <ul>

                  <li className="py-2 d-flex align-items-start justify-content-between gap-10">
                    <label
                      htmlFor=""
                      className={`${styles.formLabel} fw-sbold mb-0 form-label themeClr w-50`}
                    >
                      Account Number
                    </label>
                    <p className=" m-0 fw-sbold w-75 ">
                      {vendorDatas?.accountDetails?.length > 0 && `xxxx xxxx xxxx ${vendorDatas?.accountDetails[0]?.accountNumber}` || '--'}
                    </p>
                  </li>
                  <li className="py-2 d-flex align-items-start justify-content-between gap-10">
                    <label
                      htmlFor=""
                      className={`${styles.formLabel} fw-sbold mb-0 form-label themeClr w-50`}
                    >
                      Routing Number
                    </label>
                    <p className=" m-0 fw-sbold w-75 ">
                      {vendorDatas?.accountDetails?.length > 0 && `${vendorDatas?.accountDetails[0]?.routingNumber}` || '--'}
                    </p>
                  </li>
                  <li className="py-2 d-flex align-items-start justify-content-between gap-10">
                    <label
                      htmlFor=""
                      className={`${styles.formLabel} fw-sbold mb-0 form-label themeClr w-50`}
                    >
                      Account Holder Name
                    </label>
                    <p className=" m-0 fw-sbold w-75 ">
                      {vendorDatas?.accountDetails?.length > 0 && vendorDatas?.accountDetails[0]?.accountHolderName || '--'}
                    </p>
                  </li><li className="py-2 d-flex align-items-start justify-content-between gap-10">
                    <label
                      htmlFor=""
                      className={`${styles.formLabel} fw-sbold mb-0 form-label themeClr w-50`}
                    >
                      Bank Name
                    </label>
                    <p className=" m-0 fw-sbold w-75 ">
                      {vendorDatas?.accountDetails?.length > 0 && vendorDatas?.accountDetails[0]?.bankName || '--'}
                    </p>
                  </li>
                  <li className="py-2 d-flex align-items-start justify-content-between gap-10">
                    <label
                      htmlFor=""
                      className={`${styles.formLabel} fw-sbold mb-0 form-label themeClr w-50`}
                    >
                      Stripe Account Status
                    </label>
                    <p className=" m-0 fw-sbold w-75 StatusGreen">
                      {vendorDatas?.stripeConnectStatus && "Connected"}
                    </p>
                  </li>


                </ul>
              </div>
            </Col>
            <Col lg="6" className="my-2">
              <h5 className="m-0 pb-2 fw-sbold themeBlue mt-4">
                Widget Details:
              </h5>
              <div className="box cardCstm p-3 px-lg-4 position-relative">

                <div className="widgetDiv border">
                  {widgetCode}

                  <Button onClick={handleCopyWidget} className="copyBtn">
                    {widgetCopied ?

                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-clipboard-check" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0" />
                        <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1z" />
                        <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0z" />
                      </svg>

                      :
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-clipboard" viewBox="0 0 16 16">
                        <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1z" />
                        <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0z" />
                      </svg>
                    }
                  </Button>
                </div>

              </div>
            </Col>
            <Col lg="6" className="my-2">
              <h5 className="m-0 pb-2 fw-sbold themeBlue mt-4">
                Document:
              </h5>
              <div className="box cardCstm p-3 px-lg-4 position-relative">
                <Col
                  md="12"
                  className="my-2"
                >

                  <Slider {...settings}>
                    {vendorDatas?.documentsList?.map(
                      (item, index) => {
                        const { image } = item;

                        return (
                          <div>
                            <div
                              key={index}
                              className="cardCstm border text-center rounded px-3 py-2 d-flex justify-content-center align-items-center"
                              style={{ border: "black", height: "auto" }}
                            >
                              {/* <img
                                                    src={image || d1}
                                                    alt=""
                                                    // className="img-fluid mx-auto"
                                                    style={{
                                                      width: 100,
                                                      height: 100,
                                                    }}
                                                  /> */}
                              <img
                                src={image || d1}
                                alt="document"
                                // className="img-fluid object-fit-contain"
                                style={{
                                  height: 300,
                                  width: 300,
                                  cursor: "pointer",
                                  margin: "28px",
                                  borderRadius: "0.5rem"
                                }}
                                onClick={() => handleImageClick(image || d1)}
                              />
                            </div>
                          </div>
                        );
                      }
                    )}
                  </Slider>
                </Col>
                <Modal show={showModal} onHide={handleClose} centered>
                  <Modal.Header closeButton>
                    {/* <Modal.Title>Document Preview</Modal.Title> */}
                  </Modal.Header>
                  <Modal.Body className="text-center">
                    {selectedImage && (
                      <img
                        src={selectedImage}
                        alt="Document Preview"
                        className="img-fluid"
                        style={{ maxHeight: "500px" }}
                      />
                    )}
                  </Modal.Body>
                </Modal>
              </div>
            </Col>
          </Row>

        </Container >
      </section >
    </>
  );
};

export default VendorDetail;
